<template>
  <div id="pagePartnerGroup" @click="handleClickOutside">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="partner-group-card elevation-2">
            <!-- Header mejorado -->
            <v-toolbar color="primary" dark flat>
              <v-icon class="mr-2">mdi-account-group</v-icon>
              <v-toolbar-title v-if="!$vuetify.breakpoint.mdAndDown">Grupos de Partners</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Búsqueda para escritorio -->
              <v-col cols="3" class="mr-3" v-if="!$vuetify.breakpoint.mdAndDown">
                <v-text-field
                  v-model="filter.search"
                  label="Buscar grupo..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                ></v-text-field>
              </v-col>
              <!-- Búsqueda para móvil -->
              <v-tooltip top v-if="$vuetify.breakpoint.mdAndDown && !showSearch">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click.stop="toggleSearch">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>
              <v-col cols="12" v-if="showSearch && $vuetify.breakpoint.mdAndDown">
                <v-text-field
                  ref="searchInput"
                  v-model="filter.search"
                  label="Buscar grupo..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                  @keydown.esc="showSearch = false"
                ></v-text-field>
              </v-col>

              <!-- Botón para agregar grupo -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="showGroupForm(null)" class="mr-2" color="white">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Crear Grupo de Partners</span>
              </v-tooltip>
              <!-- Botón para refrescar -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="refreshDataTable" v-on="on" color="white" class="mr-0">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar lista</span>
              </v-tooltip>
            </v-toolbar>
            <!-- Selector de vista (tarjetas/tabla) -->
            <v-card-actions class="px-4 py-2">
              <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2">
                {{ totalItems }} grupo(s) de partners
              </div>
              <v-spacer></v-spacer>
              <v-btn-toggle
                v-model="viewMode"
                mandatory
                dense
                color="primary"
              >
                <v-btn value="cards" small>
                  <v-icon small>mdi-view-grid-outline</v-icon>
                  Tarjetas
                </v-btn>
                <v-btn value="table" small>
                  <v-icon small>mdi-table</v-icon>
                  Tabla
                </v-btn>
              </v-btn-toggle>
            </v-card-actions>
            <!-- Vista de tarjetas -->
            <v-card-text v-if="viewMode === 'cards'" class="px-4 pt-0 pb-4">
              <!-- Estado de carga -->
              <v-row v-if="loadingItems">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="`skeleton-${n}`">
                  <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                </v-col>
              </v-row>              <!-- Estado sin resultados -->
              <v-row v-else-if="!filteredGroups.length" class="text-center py-5">
                <v-col cols="12">
                  <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-account-group-outline</v-icon>
                  <h3 class="text-h5 grey--text text--darken-1 mb-2">No se encontraron grupos</h3>
                  <p class="text-subtitle-1 grey--text mb-6">Crea un nuevo grupo de partners para comenzar</p>
                  <v-btn color="primary" @click="showGroupForm(null)">
                    <v-icon left>mdi-plus</v-icon>
                    Crear Grupo
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Lista de grupos en tarjetas -->
              <v-row v-else>
                <v-col cols="12" sm="6" md="4" lg="3" v-for="group in filteredGroups" :key="group.id">
                  <v-card
                    class="group-card-item h-100"
                    outlined
                    hover
                  >
                  <v-card-text class="pa-4">
                    <!-- Avatar y estado -->
                    <div class="d-flex mb-4">
                      <v-avatar size="56" color="primary lighten-4" class="mr-3">
                        <v-icon size="32" color="primary">mdi-account-group</v-icon>
                      </v-avatar>
                      <div class="flex-grow-1">
                        <div class="subtitle-1 font-weight-bold mb-1">
                          {{ group.name }}
                        </div>
                        <v-chip x-small color="primary" outlined>
                          <v-icon x-small left>mdi-store</v-icon>
                          {{ group.dealerships_count }} Partner(s)
                        </v-chip>
                        <v-chip x-small class="ml-1" v-if="group.grupo">
                          <v-icon x-small left>mdi-shield-account</v-icon>
                          {{ group.grupo.name }}
                        </v-chip>
                      </div>
                    </div>
                    <!-- Información básica -->
                    <div v-if="group.description" class="text-body-2 grey--text text--darken-2">
                      {{ group.description }}
                    </div>
                    <div v-else class="text-body-2 grey--text font-italic">
                      Sin descripción
                    </div>
                  </v-card-text>
                    <v-divider></v-divider>
                    <!-- Acciones de tarjeta -->
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon small color="info" @click.stop="showGroupDetails(group)" title="Ver detalles">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn icon small color="purple" @click.stop="viewGroupUsers(group)" title="Ver usuarios">
                        <v-icon>mdi-account-group</v-icon>
                      </v-btn>
                      <v-btn icon small color="primary" @click.stop="showGroupForm(group)" title="Editar">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon small color="error" @click.stop="confirmDeleteGroup(group)" title="Eliminar">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Paginación en vista de tarjetas -->
              <div class="text-center pt-4" v-if="!loadingItems && filteredGroups.length > 0">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center flex-wrap pa-2">
                    <div class="text-center d-flex align-center mr-4">
                      <span class="text-body-2 grey--text text--darken-1">Filas por página:</span>
                      <v-select v-model="pagination.itemsPerPage" :items="footer.itemsPerPageOptions" dense outlined
                        hide-details class="ml-2" style="width: 80px;" @change="onItemsPerPageChange"></v-select>
                    </div>

                    <v-pagination v-model="pagination.page" :length="Math.ceil(totalItems / pagination.itemsPerPage)"
                      :total-visible="7" circle @input="onPageChange"></v-pagination>

                    <span class="text-body-2 grey--text text--darken-1 ml-4">
                      {{ paginationText }}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <!-- Vista de tabla -->
            <v-card-text v-else class="pa-0">
              <v-data-table
                :headers="headers"
                :items="filteredGroups"
                :options.sync="pagination"
                :loading="loadingItems"
                :footer-props="footer"
                :key="tableId"
                item-key="id"
                class="elevation-0"
                multi-sort
                :server-items-length="totalItems"
              >
                <!-- Columna de nombre -->
                <template v-slot:item.name="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="primary lighten-4" class="mr-2">
                      <v-icon size="20" color="primary">mdi-account-group</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium">{{ item.name }}</div>
                    </div>
                  </div>
                </template>
                
                <!-- Columna de descripción -->
                <template v-slot:item.description="{ item }">
                  <div v-if="item.description" class="text-body-2">
                    {{ item.description }}
                  </div>
                  <div v-else class="grey--text font-italic">Sin descripción</div>
                </template>
                
                <!-- Columna de grupo -->
                <template v-slot:item.grupo="{ item }">
                  <span v-if="item.grupo">{{ item.grupo.name }}</span>
                  <span v-else class="grey--text">—</span>
                </template>

                <!-- Columna de número de partners -->
                <template v-slot:item.partners_count="{ item }">
                  <v-chip small color="primary" outlined>
                    <v-icon small left>mdi-store</v-icon>
                    {{ item.dealerships_count  }}
                  </v-chip>
                </template>
                
                <!-- Columna de managers -->
                <template v-slot:item.managers="{ item }">
                  <div v-if="item.dealerships && item.dealerships.length > 0" class="managers-list">
                    <div v-for="dealer in item.dealerships.slice(0, 3)" :key="dealer.id" class="text-caption d-flex align-center">
                      <v-tooltip top v-if="dealer.balance?.subscription_status !== 'active'">
                        <template v-slot:activator="{ on }">
                          <v-icon x-small color="warning" class="mr-1" v-on="on">mdi-alert</v-icon>
                        </template>
                        <span>Suscripción no activa</span>
                      </v-tooltip>
                      <v-icon x-small color="grey darken-1">mdi-account-tie</v-icon>
                      <span class="ml-1">
                        {{ dealer.admin ? `${dealer.admin.name} ${dealer.admin.lastname}` : 'Sin manager' }}
                      </span>
                    </div>
                    <div v-if="item.dealerships.length > 3" class="text-caption grey--text">
                      <v-icon x-small>mdi-dots-horizontal</v-icon>
                      +{{ item.dealerships.length - 3 }} más
                    </div>
                  </div>
                  <div v-else class="grey--text font-italic text-caption">
                    Sin dealers
                  </div>
                </template>
                
                <!-- Columna de acciones -->
                <template v-slot:item.action="{ item }">
                  <div class="d-inline-flex action-buttons">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="info"
                          @click.stop="showGroupDetails(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalles</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="info"
                          @click.stop="viewGroupUsers(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-account-group</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver usuarios del grupo</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click.stop="showGroupForm(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="error"
                          @click.stop="confirmDeleteGroup(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    
    <!-- Dialog para crear/editar grupo -->
    <v-dialog v-model="groupDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-account-group</v-icon>
          <span>{{ editingGroup ? 'Editar Grupo' : 'Crear Grupo de Partners' }}</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.name"
              label="Nombre del Grupo *"
              prepend-inner-icon="mdi-format-title"
              outlined
              dense
              :rules="[v => !!v || 'El nombre es requerido']"
              required
              hint="Ej: Grupo Barcelona, Partners Madrid, etc."
              persistent-hint
            ></v-text-field>

            <v-textarea
              v-model="formData.description"
              label="Descripción"
              prepend-inner-icon="mdi-text"
              outlined
              dense
              rows="3"
              class="mt-4"
              hint="Descripción opcional del grupo"
              persistent-hint
            ></v-textarea>

            <v-autocomplete
              v-model="formData.dealership_ids"
              :items="allDealers"
              :loading="loadingDealers"
              item-text="name"
              item-value="id"
              label="Seleccionar Partners (Dealers) *"
              prepend-inner-icon="mdi-store"
              outlined
              dense
              multiple
              chips
              small-chips
              deletable-chips
              class="mt-4"
              :rules="[v => (v && v.length >= 2) || 'Debe seleccionar al menos 2 partners']"
              required
              hint="Seleccione al menos 2 dealers que formarán parte de este grupo"
              persistent-hint
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 5" small close @click:close="removeDealer(item.id)">
                  <v-icon small left>mdi-store</v-icon>
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 5" class="grey--text text-caption ml-2">
                  (+{{ formData.dealership_ids.length - 5 }} más)
                </span>
              </template>
              
              <template v-slot:item="{ item }">
                <v-list-item-avatar color="primary lighten-4">
                  <v-icon color="primary">mdi-store</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.city">
                    <v-icon small>mdi-map-marker</v-icon>
                    {{ item.city }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            
            <v-alert v-if="formData.dealership_ids && formData.dealership_ids.length > 0" type="info" dense text class="mt-2">
              <v-icon small left>mdi-information</v-icon>
              {{ formData.dealership_ids.length }} partner(s) seleccionado(s)
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeGroupDialog" :disabled="saving">
            Cancelar
          </v-btn>
          <v-btn color="primary" :disabled="!valid" :loading="saving" @click="saveGroup">
            <v-icon left>mdi-content-save</v-icon>
            {{ editingGroup ? 'Actualizar' : 'Crear' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Diálogo de confirmación de eliminación -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline error--text">
          <v-icon left color="error">mdi-alert</v-icon>
          Confirmar eliminación
        </v-card-title>
        <v-card-text class="py-4">
          <v-row>
            <v-col cols="auto" class="pr-0">
              <v-avatar color="error" size="48" class="mr-4">
                <v-icon dark>mdi-account-group</v-icon>
              </v-avatar>
            </v-col>
            <v-col>
              <p class="mb-1">¿Estás seguro de que deseas eliminar este grupo de partners?</p>
              <p class="subtitle-1 font-weight-medium">{{ groupToDelete?.name }}</p>
              <p class="caption grey--text" v-if="groupToDelete?.dealership_ids">
                Partners: {{ groupToDelete.dealership_ids.length }}
              </p>
            </v-col>
          </v-row>
          <v-alert type="warning" dense text class="mt-3">
            Esta acción no se puede deshacer.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false" :disabled="deleting">Cancelar</v-btn>
          <v-btn color="error" :loading="deleting" @click="deleteGroup">
            <v-icon left>mdi-delete</v-icon>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Diálogo de detalles del grupo -->
    <v-dialog v-model="detailsDialog" max-width="800px" scrollable>
      <v-card>
        <v-card-title class="info white--text">
          <v-icon color="white" class="mr-2">mdi-account-group</v-icon>
          <span>Detalles del Grupo</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6" v-if="selectedGroup">
          <!-- Información del grupo -->
          <v-row class="mb-4">
            <v-col cols="12">
              <div class="d-flex align-center mb-3">
                <v-avatar size="64" color="info lighten-4" class="mr-4">
                  <v-icon size="40" color="info">mdi-account-group</v-icon>
                </v-avatar>
                <div>
                  <h2 class="text-h5 font-weight-bold">{{ selectedGroup.name }}</h2>
                  <v-chip small color="info" outlined class="mt-1">
                    <v-icon small left>mdi-store</v-icon>
                    {{ selectedGroup.dealerships_count }} Partner(s)
                  </v-chip>
                  <v-chip small class="mt-1 ml-1" v-if="selectedGroup.grupo">
                    <v-icon small left>mdi-shield-account</v-icon>
                    Grupo: {{ selectedGroup.grupo.name }}
                  </v-chip>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <!-- Descripción -->
          <v-row class="mb-4">
            <v-col cols="12">
              <div class="text-overline grey--text">Descripción</div>
              <p v-if="selectedGroup.description" class="text-body-1 mb-0">
                {{ selectedGroup.description }}
              </p>
              <p v-else class="grey--text font-italic mb-0">
                Sin descripción
              </p>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <!-- Listado de dealers -->
          <v-row>
            <v-col cols="12">
              <div class="text-overline grey--text mb-3">
                <v-icon small>mdi-store</v-icon>
                Partners / Dealers ({{ selectedGroup.dealerships ? selectedGroup.dealerships.length : 0 }})
              </div>
              
              <div v-if="selectedGroup.dealerships && selectedGroup.dealerships.length > 0">
                <v-list two-line class="py-0">
                  <div v-for="(dealer, index) in selectedGroup.dealerships" :key="dealer.id">
                    <v-list-item>
                      <v-list-item-avatar color="primary lighten-4">
                        <v-icon color="primary">mdi-store</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{ dealer.name }}
                          <v-tooltip top v-if="dealer.balance?.subscription_status !== 'active'">
                            <template v-slot:activator="{ on }">
                              <v-icon small color="warning" class="ml-2" v-on="on">mdi-alert-circle</v-icon>
                            </template>
                            <span>Suscripción {{ dealer.balance?.subscription_status || 'inactiva' }}</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-icon x-small color="grey darken-1">mdi-account-tie</v-icon>
                          Manager: 
                          <span class="font-weight-medium">
                            {{ dealer.admin ? `${dealer.admin.name} ${dealer.admin.lastname}` : 'Sin asignar' }}
                          </span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="dealer.admin && dealer.admin.email">
                          <v-icon x-small>mdi-email</v-icon>
                          {{ dealer.admin.email }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="dealer.admin && dealer.admin.phone">
                          <v-icon x-small>mdi-phone</v-icon>
                          {{ dealer.admin.phone }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action v-if="dealer.admin">
                        <v-chip x-small :color="dealer.admin.status === 10 ? 'success' : 'grey'" outlined>
                          {{ dealer.admin.status === 10 ? 'Activo' : 'Inactivo' }}
                        </v-chip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index < selectedGroup.dealerships.length - 1"></v-divider>
                  </div>
                </v-list>
              </div>
              
              <v-alert v-else type="info" text dense>
                <v-icon small left>mdi-information</v-icon>
                Este grupo no tiene dealers asignados
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="detailsDialog = false">
            Cerrar
          </v-btn>
          <v-btn color="primary" @click="editFromDetails">
            <v-icon left>mdi-pencil</v-icon>
            Editar Grupo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PartnerGroupService from '@/services/PartnerGroupService'
import DealerService from '@/services/DealerService'
import GrupoPanelService from '@/services/GrupoPanelService'

export default {
  name: 'PartnerGroupView',
  data() {
    return {
      groups: [],
      allDealers: [],
      loadingItems: false,
      loadingDealers: false,
      saving: false,
      deleting: false,
      totalItems: 0,
      showSearch: false,
      groupDialog: false,
      deleteDialog: false,
      detailsDialog: false,
      editingGroup: null,
      groupToDelete: null,
      selectedGroup: null,
      valid: false,
      manualViewMode: null,
      tableId: 0,
      
      filter: {
        search: null
      },
      
      formData: {
        name: '',
        description: '',
        dealership_ids: []
      },
      
      // Headers para la tabla
      headers: [
        {
          text: 'Nombre del Grupo',
          value: 'name',
          sortable: true,
          width: '25%'
        },
        {
          text: 'Descripción',
          value: 'description',
          sortable: false,
          width: '30%'
        },
        {
          text: 'Grupo',
          value: 'grupo',
          sortable: false,
          width: '12%'
        },
        {
          text: 'Nº Partners',
          value: 'partners_count',
          align: 'center',
          width: '12%'
        },
        {
          text: 'Managers',
          value: 'managers',
          sortable: false,
          width: '20%'
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
          align: 'center',
          width: '13%'
        }
      ],
      
      footer: {
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        itemsPerPageText: 'grupos por página:',
        pageText: '{0}-{1} de {2}'
      },
      
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      }
    }
  },
  computed: {
    viewMode: {
      get() {
        if (this.manualViewMode) {
          return this.manualViewMode
        }
        if (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp) {
          return 'table'
        }
        return 'cards'
      },
      set(value) {
        this.manualViewMode = value
      }
    },
    
    filteredGroups() {
      if (!this.filter.search) return this.groups
      const searchLower = this.filter.search.toLowerCase()
      return this.groups.filter(group =>
        group.name.toLowerCase().includes(searchLower) ||
        (group.description && group.description.toLowerCase().includes(searchLower))
      )
    },
    
    paginationText() {
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
      const end = Math.min(start + this.pagination.itemsPerPage - 1, this.totalItems)
      return `${start}-${end} de ${this.totalItems}`
    }
  },
  mounted() {
    this.loadGroups()
    this.loadDealers()
  },
  methods: {
    async loadGroups() {
      this.loadingItems = true
      try {
        const response = await PartnerGroupService.index({ expand: 'dealerships.admin,dealerships.balance' })
        console.log('Respuesta de grupos:', response)
        this.groups = response.data.data || response.data || []
        this.totalItems = this.groups.length
        console.log('Grupos cargados:', this.groups)
      } catch (error) {
        console.error('Error al cargar grupos:', error)
        this.$toast.error('Error al cargar los grupos de partners')
      } finally {
        this.loadingItems = false
      }
    },
    
    async loadDealers() {
      this.loadingDealers = true
      try {
        // Administrador de Grupo: solo los dealers activos de su grupo
        if (this.$store.getters.IS_GROUP_ADMIN) {
          const response = await GrupoPanelService.dealers()
          this.allDealers = ((response.data && response.data.data) || []).filter(dealer => dealer.status === 10)
          return
        }
        // El backend usa 'per-page' (con guión) y tiene un límite máximo de 50
        const response = await DealerService.get({ 
          'per-page': 100
        })
        const allDealers = response.data.data || response.data || []
        console.log('Total de dealers recibidos:', allDealers.length)
        // Filtrar solo dealers con balance != null y suscripción activa
        this.allDealers = allDealers.filter(dealer => dealer.balance != null && dealer.balance.subscription_status === 'active')
        console.log('Dealers activos cargados:', this.allDealers.length)
      } catch (error) {
        console.error('Error al cargar dealers:', error)
        this.$toast.error('Error al cargar la lista de partners')
      } finally {
        this.loadingDealers = false
      }
    },
    
    showGroupForm(group = null) {
      console.log('========== showGroupForm INICIADO ==========')
      console.log('Grupo recibido:', group)
      console.log('allDealers disponibles:', this.allDealers ? this.allDealers.length : 0)
      
      if (group) {
        this.editingGroup = group
        
        console.log('group.dealerships:', group.dealerships)
        console.log('group.dealership_ids:', group.dealership_ids)
        
        // Los dealerships ya vienen cargados en el grupo, no necesitamos hacer otra petición
        const dealershipIds = group.dealerships && Array.isArray(group.dealerships)
          ? group.dealerships.map(d => d.id)
          : (group.dealership_ids || [])
        
        console.log('dealershipIds calculados:', dealershipIds)
        console.log('Tipo de dealershipIds:', Array.isArray(dealershipIds) ? 'Array' : typeof dealershipIds)
        
        this.formData = {
          name: group.name,
          description: group.description || '',
          dealership_ids: dealershipIds
        }
        
        console.log('FormData asignado:', this.formData)
        console.log('this.formData.dealership_ids:', this.formData.dealership_ids)
        
        // Verificar si los IDs existen en allDealers
        if (this.allDealers && this.allDealers.length > 0) {
          const foundDealers = this.allDealers.filter(d => dealershipIds.includes(d.id))
          console.log('Dealers encontrados en allDealers:', foundDealers)
          console.log('Cantidad de dealers encontrados:', foundDealers.length, 'de', dealershipIds.length)
        } else {
          console.warn('⚠️ allDealers está vacío o no existe')
        }
      } else {
        console.log('Nuevo grupo (sin datos previos)')
        this.editingGroup = null
        this.formData = {
          name: '',
          description: '',
          dealership_ids: []
        }
      }
      
      console.log('FormData FINAL antes de abrir diálogo:', this.formData)
      
      // Abrir el diálogo
      this.groupDialog = true
      console.log('Diálogo abierto: groupDialog =', this.groupDialog)
      
      // Esperar al siguiente tick para resetear validaciones
      this.$nextTick(() => {
        console.log('$nextTick - FormData en el momento de resetear validación:', this.formData)
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
          console.log('Validación reseteada')
        }
      })
      
      console.log('========== showGroupForm FINALIZADO ==========')
    },
    
    closeGroupDialog() {
      this.groupDialog = false
      this.editingGroup = null
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    
    removeDealer(dealerId) {
      const index = this.formData.dealership_ids.indexOf(dealerId)
      if (index > -1) {
        this.formData.dealership_ids.splice(index, 1)
      }
    },
    
    async saveGroup() {
      if (!this.$refs.form.validate()) return
      
      this.saving = true
      try {
        const payload = {
          name: this.formData.name,
          description: this.formData.description,
          dealership_ids: this.formData.dealership_ids
        }
        
        console.log('Guardando grupo:', payload)
        
        if (this.editingGroup) {
          await PartnerGroupService.update(this.editingGroup.id, payload)
          this.$toast.success('Grupo actualizado correctamente')
        } else {
          await PartnerGroupService.create(payload)
          this.$toast.success('Grupo creado correctamente')
        }
        
        this.closeGroupDialog()
        await this.loadGroups()
      } catch (error) {
        console.error('Error al guardar grupo:', error)
        const errorMsg = error.response?.data?.message || 'Error al guardar el grupo'
        this.$toast.error(errorMsg)
      } finally {
        this.saving = false
      }
    },
    
    confirmDeleteGroup(group) {
      this.groupToDelete = group
      this.deleteDialog = true
    },
    
    showGroupDetails(group) {
      this.selectedGroup = group
      this.detailsDialog = true
    },
    
    viewGroupUsers(group) {
      // Navegar a la vista de usuarios del grupo
      this.$router.push({
        name: 'PartnerGroupUsers',
        params: {
          groupId: group.id,
          groupName: group.name
        }
      })
    },
    
    editFromDetails() {
      this.detailsDialog = false
      this.showGroupForm(this.selectedGroup)
    },
    
    async deleteGroup() {
      this.deleting = true
      try {
        await PartnerGroupService.delete(this.groupToDelete.id)
        this.$toast.success('Grupo eliminado correctamente')
        this.deleteDialog = false
        this.groupToDelete = null
        await this.loadGroups()
      } catch (error) {
        console.error('Error al eliminar grupo:', error)
        const errorMsg = error.response?.data?.message || 'Error al eliminar el grupo'
        this.$toast.error(errorMsg)
      } finally {
        this.deleting = false
      }
    },
    
    refreshDataTable() {
      this.tableId++
      this.loadGroups()
    },
    
    toggleSearch() {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    },
    
    handleClickOutside(event) {
      const searchInput = this.$refs.searchInput
      if (searchInput && !searchInput.$el.contains(event.target)) {
        this.showSearch = false
      }
    },
    
    onPageChange(page) {
      this.pagination.page = page
    },
    
    onItemsPerPageChange(perPage) {
      this.pagination.itemsPerPage = perPage
      this.pagination.page = 1
    }
  }
}
</script>

<style scoped>
.partner-group-card {
  border-radius: 8px;
  overflow: hidden;
}

.group-card-item {
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease;
  display: flex;
  flex-direction: column;
}

.group-card-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.h-100 {
  height: 100%;
}

.action-buttons button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-buttons button:hover {
  opacity: 1;
}

.search-input-mobile {
  max-width: 200px;
}

.flex-grow-1 {
  flex-grow: 1;
}

.managers-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.managers-list > div {
  display: flex;
  align-items: center;
}

/* Animación para nuevos elementos */
@keyframes highlight {
  0% {
    background-color: rgba(var(--v-primary-base), 0.1);
  }
  100% {
    background-color: transparent;
  }
}

.new-item {
  animation: highlight 2s ease-in-out;
}
</style>
